import { CheckCircle, ListPlus } from "lucide-react"

import { FrontendTriggerDefinition } from "@/components/automations/types"

export const taskTriggers: FrontendTriggerDefinition[] = [
  {
    key: "trigger__task_created",
    label: "Task created",
    description: "Triggers when a new task is created",
    icon: ListPlus,
    providesSubjects: ["task", "household"],
    inputFields: [
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "task",
      },
    ],
  },
  {
    key: "trigger__task_completed",
    label: "Task completed",
    description: "Triggers when a task is completed",
    icon: CheckCircle,
    providesSubjects: ["task", "household"],
    inputFields: [
      {
        key: "filter_group",
        label: "Continue if...",
        inputType: "filter_group",
        required: false,
        filterEntity: "task",
      },
    ],
  },
]
